<template>
  <div>Hello from Favorite</div>
</template>

<script>
export default {
  name: "Favorite"
};
</script>

<style lang="scss" scoped>
</style>